import React, { useState, useEffect } from 'react';
import { Box, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { OKRButton } from '../../../../../Common/OKRButton';
import { BottomArrowIcon } from '../../../../../../config/svg/CommonSvgIcon';

export const KpiCategoryNameDropdown: React.FC<any> = (props: any) => {
	const {
		fetchKpiCategories,
		categories,
		openCategory,
		selectedCategory,
		handleClick,
		handleClickAway,
		handleCategorySelect,
		okrNameError,
		mode,
	} = props;

	// Fetch categories from API
	useEffect(() => {
		fetchKpiCategories();
	}, []);
	//
	return (
		<Box
			className={`okr-team-dropdown kpi-category-dropdown ${openCategory ? 'active' : ''} ${
				okrNameError.error && okrNameError.errorText ? 'helperText-bottom' : ''
			}`}
		>
			<OKRButton
				className={`dropdown-button ${selectedCategory ? 'selected-btn' : ''}`}
				icon={<BottomArrowIcon />}
				disabled={mode === 'Edit'}
				handleClick={handleClick}
				text={selectedCategory || 'Select KPI Category'}
			/>
			{okrNameError.error && okrNameError.errorText ? (
				<Typography className='error-field'>{okrNameError.errorText}</Typography>
			) : (
				<></>
			)}
			{openCategory && (
				<ClickAwayListener onClickAway={handleClickAway}>
					<Box className='team-dropdown'>
						<Box className='team-dropdown-inner'>
							<Box className='dropdown-multi-list-sub-panel'>
								<List component='div' disablePadding>
									{categories.map((category: any, index: any) => (
										<ListItem key={index} component='div' onClick={() => handleCategorySelect(category)}>
											<ListItemText primary={category?.name} />
										</ListItem>
									))}
								</List>
							</Box>
						</Box>
					</Box>
				</ClickAwayListener>
			)}
		</Box>
	);
};
